module.exports = __webpack_public_path__ + "img/header-xxl.af934e49.png";